export const GET_MOVIE_PENDING = 'films/GET_MOVIE_PENDING';
export const GET_MOVIE_SUCCESS = 'films/GET_MOVIE_SUCCESS';
export const GET_MOVIE_FAILURE = 'films/GET_MOVIE_FAILURE';